import React from "react";
import paperpin from "../../../assests/images/paperpin.svg";

export const PacketFooter = ({ item, childPacket }) => {
  console.log(childPacket);
  return (
    <div className="packetfooter">
      <div>
        {item > 0 ? (
          <img src={paperpin} />
        ) : (
          // <div className="EwayBill">Eway Bill</div>
          ""
        )}
      </div>
      {item > 0 ? (
        <div className="EwayBill">Child Packet </div>
      ) : (
        // <div className="EwayBill">Eway Bill</div>
        ""
      )}
    </div>
  );
};
